export default "__VITE_ASSET__DaXWXXmR__"